module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.iso) ? _c('span', {
    staticClass: "flag-icon",
    class: _vm.flagIconClass,
    attrs: {
      "title": _vm.title || _vm.iso
    }
  }) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e888144","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-flag-icon/components/icon/Flag.vue
// module id = 758
// module chunks = 31